import { render } from "./PlanTable.vue?vue&type=template&id=4dc7e2c9&scoped=true"
import script from "./PlanTable.vue?vue&type=script&lang=js"
export * from "./PlanTable.vue?vue&type=script&lang=js"

import "./PlanTable.vue?vue&type=style&index=0&id=4dc7e2c9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc7e2c9"]])

export default __exports__